import { withApp } from "@/components/App"
import Slice from "@/daily_settlement/Slice"

import DailySettlementCard from "./DailySettlementCard"

export default withApp(DailySettlementCard, { slices: [Slice] })
